export enum StoreReservoir {
  STORE_LIBRARY = 'TIENDAS_Biblioteca',
  ACCESOS_ITEMS = 'TIENDAS_Accesos_de_Interes',
  MANUAL_CATEGORIES = 'TIENDAS_Categorias_Manuales',
  MANUAL_ITEMS = 'TIENDAS_Manuales',
  PLANOGRAMS_CATEGORIES = 'TIENDAS_Categorias_Planogramas',
  PLANOGRAMS_ITEMS = 'TIENDAS_Planogramas',
  ADVISORS = 'TIENDAS_Asesores',
  NOVEDADES = 'TIENDAS_Lanzamientos_Novedades',
  SPECIAL_PROMOTIONS_ITEMS = 'TIENDAS_Promociones_Especiales',
  PROMOTIONS_LINKS = 'TIENDAS_Calendario_Promociones_Links',
  PROMOTIONS_SLIDER = 'TIENDAS_Calendario_Promociones_Slider',
  RECLAIMS = 'TIENDAS_Reclamos',
  MARKETPLACE_SLIDER = 'TIENDAS_Marketplace_Slider',
  MARKETPLACE_CATEGORIES = 'TIENDAS_Categorias_Marketplace',
  MARKETPLACE_ITEMS = 'TIENDAS_Marketplace',
  SLIDER = 'TIENDAS_Slider',
  TIENDAS_STANDAR_SLIDER = 'TIENDAS_PARADASANGUCHERA_Slider',
  TIENDAS_STANDAR_CATEGORIA = 'TIENDAS_Categorias_PARADASANGUCHERA',
  TIENDAS_STANDAR_ITEMS = 'TIENDAS_PARADASANGUCHERA',
  TIENDAS_EXPRESS_SLIDER = 'TIENDAS_PARADASANGUCHERA_EXPRESS_Slider',
  TIENDAS_EXPRESS_CATEGORIA = 'TIENDAS_Categorias_PARSANGUCHERAEXPRESS',
  TIENDAS_EXPRESS_ITEMS = 'TIENDAS_PARSANGUCHERAEXPRESS',
}
